module.exports = __webpack_public_path__ + "img/reportChicken_6.1734ec7c.png";